<template>
  <a-modal
    v-if="!loading"
    :title="editFieldTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :width="640"
    :centered="true"
    :mask-closable="false"
    wrap-class-name="edit-files-modal"
    :ok-text="okTTxt"
    :destroy-on-close="true"
    :cancel-text="cancelTxt"
    @ok="handleOk"
    @cancel="hide"
  >
    <div class="content clearfix">
      <div class="left fl">
        <h3>{{ $t('message["570"]') }}</h3>
        <div
          v-show="treeData"
          class="result scroll_bar_beautify_ff"
        >
          <a-tree
            ref="treeList"
            checkable
            :tree-data="treeData"
            :checked-keys="checkedKeys"
            @check="onCheck"
          />
        </div>
      </div>
      <span class="border" />
      <div class="right fl">
        <h3>{{ $t('message["1479"]') }}</h3>
        <transition-group class="result scroll_bar_beautify_ff">
          <div
            v-for="(item, i) in myList"
            :key="i"
            class="item clearfix"
            :class="{ 'active': item.active}"
          >
            <div class="fl">
              <span>{{ item.fieldname }}</span>
            </div>
            <i
              class="iconfont iconicon-test5 fr close-icon"
              @click="onDeleteItem(item, i)"
            />
          </div>
        </transition-group>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: false,
      confirmLoading: false,
      checkedKeys: []
    }
  },
  computed: {
    ...mapState('config/smart', ['baseConfig', 'loading', 'filterSort']),
    treeData () {
      let obj = {}
      obj.child = this.baseConfig.edit
      obj = this.prepareTreeData(obj)
      return obj.children
    },
    myList: {
      get () {
        return _.reduce(this.filterSort, (res, item) => {
          res.push(item)
          return res
        }, [])
      },
      set (value) {
        this.SET_FILTER_SORT(value)
      }
    },
    editFieldTit () {
      return this.$t('message["44"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
      val && this.prepareInitData()
    },
    treeData (val) {
      this.checkedKeys = []
      this.getCheckedKeys(val)
    }
  },
  created () {
    this.getCheckedKeys(this.treeData)
  },
  methods: {
    ...mapActions('config/smart', ['setFormConfig']),
    ...mapMutations('config/smart', ['SET_FILTER_SORT']),
    prepareInitData () {
      if ('edit' in this.baseConfig) {
        for (let i = 0; i < this.baseConfig.edit.length; i++) {
          let item = this.baseConfig.edit[i]
          let ischecked = item.ischecked === undefined ? 0 : item.ischecked
          this.$set(item, 'ischecked', ischecked)
        }
      }
    },
    hide () {
      this.$emit('update:visible', false)
    },
    onChange (item) {
      const ischecked = item.ischecked === 1 ? 0 : 1
      this.$set(item, 'ischecked', ischecked)
    },
    setFilterAllResult () {
      let arr = []
      for (let k in this.baseConfig.edit) {
        const modules = this.baseConfig.edit[k] || {}
        const child = modules.child || []
        for (let i in child) {
          let item = child[i]
          if (item.ischecked) {
            arr.push(item.fieldkey)
          }
        }
      }
      return arr
    },
    handleOk () {
      let params = this.myList.map(item => item.id)
      this.setFilter(params)
    },
    async setFilter (result) {
      await this.setFormConfig({ ids: result })
      this.myList = []
      await this.hide()
    },
    prepareTreeData (obj) {
      obj.children = []
      for (let k in obj.child) {
        let item = obj.child[k]
        item.title = item.fieldname
        item.key = item.fieldkey
        item.checked = item.ischecked === 1
        obj.children.push(item)
        if (item.child) {
          this.prepareTreeData(item)
        }
      }
      return obj
    },
    /**
     * 点击左侧树复选框的事件
     */
    onCheck (checkedKeys = [], info = {}) {
      this.checkedKeys = checkedKeys
      const { node = {} } = info
      const { dataRef = {} } = node
      const { fieldkey = '' } = dataRef
      this.setTreeDataChecked(dataRef, fieldkey)
    },
    /**
     * 通过左侧树 选中状态，获取所有checkedKeys
     */
    getCheckedKeys (children) {
      if (!children || !children.length) return
      for (let item of children) {
        if (item.ischecked) {
          if (!this.checkedKeys.includes(item.fieldkey)) {
            this.checkedKeys.push(item.fieldkey)
          }
        }
        if (item.children) {
          let checkArray = []
          item.children.map(items => {
            if (items.ischecked) {
              checkArray.push(items)
            }
          })
          if (checkArray.length === item.children.length) {
            item.ischecked = true
            this.checkedKeys.push(item.fieldkey)
          }
          this.getCheckedKeys(item.children)
        }
      }
    },
    /**
     * 左侧树 选中/取消 的值，同步到 右侧结果列表
     */
    setTreeDataChecked (currentNode, currKey) {
      if (!currentNode.children || !currentNode.children.length) { // 点的子级
        if (this.checkedKeys.includes(currKey) && !this.myList.includes(currKey)) { // 点中
          this.$set(currentNode, 'checked', true)
          this.myList.push(currentNode)
        } else {
          // 取消选中
          this.$set(currentNode, 'checked', false)
          for (let index in this.myList) {
            if (this.myList[index].fieldkey === currentNode.fieldkey) {
              this.myList.splice(index, 1)
            }
          }
        }
      } else { // 点的父级
        let arr = []
        this.mergeChildren(arr, currentNode.children)
        if (this.checkedKeys.includes(currKey)) { // 点中
          this.setChecked(currentNode.children, true)
          for (let item of arr) {
            if (!this.myList.map(items => items.fieldkey).includes(item.fieldkey)) {
              this.myList.push(item)
            }
          }
        } else { // 取消选中
          this.setChecked(currentNode.children, false)
          for (let i = this.myList.length - 1; i >= 0; i--) {
            const one = this.myList[i] || {}
            for (let item of arr) {
              if (item.fieldkey === one.fieldkey) {
                this.myList.splice(i, 1)
              }
            }
          }
        }
      }
    },
    /**
     * 左侧树 选中 父级时，合并所有子元素到一个数组
     */
    mergeChildren (arr, children) {
      if (children && children.length) {
        for (let item of children) {
          if (!item.children) {
            arr.push(item)
          } else {
            this.mergeChildren(arr, item.children)
          }
        }
      }
    },
    /**
     * 设置左侧树选中状态
     */
    setChecked (children, type) {
      if (!children || !children.length) return
      for (let item of children) {
        this.$set(item, 'checked', type)
        if (item.children) {
          this.setChecked(item.children, type)
        }
      }
    },
    // 删除右侧字段
    onDeleteItem (item, index) {
      this.myList.splice(index, 1)
      this.checkedKeys = this.myList.map(item => item.fieldkey)
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss">
.edit-files-modal {
  .ant-modal {
    padding-bottom: 0;
  }
  .ant-modal-body {
    padding: 16px 40px;
  }
  .ant-tree li span.ant-tree-switcher {
    color: #d8d8d8;
  }
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-select-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-select-switcher-icon {
    font-size: 14px;
  }
}
</style>
<style lang="scss" scoped>
.content {
  position: relative;
  h3 {
    height: 48px;
    line-height: 48px;
    font-weight: bold;
  }
  .left {
    width: 250px;
    // height: 440px;
    // overflow-y: auto;
    // overflow-x: hidden;
    margin-right: 40px;
    .result {
      max-height: 352px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .border {
    position: absolute;
    left: 250px;
    top: 0;
    width: 0;
    height: 100%;
    border-right: solid 1px $gray4;
  }
  .right {
    width: 260px;
    // height: 440px;
    // overflow-y: auto;
    // overflow-x: hidden;
    .result {
      display: block;
      max-height: 352px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .item {
      overflow: hidden;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
      &:hover {
        background-color: #f4f7f9;
        .iconfont.move-icon {
          opacity: 1;
        }
      }
    }
    .iconfont.move-icon {
      opacity: 0;
      margin-right: 4px;
      color: #ccc;
    }
    .iconfont.close-icon {
      margin-right: 20px;
      cursor: pointer;
      color: #d6d6d6;
    }
  }
}
</style>
